<template>
  <div>
    <h2>Featured lists</h2>
    <FeaturedChecklists />
  </div>
</template>

<script>
import FeaturedChecklists from '@/components/checklists_featured.vue'

export default {
  name: 'Home',
  metaInfo: {
    title: 'Lists to live by'
  },
  components: {
    FeaturedChecklists
  }
}
</script>
